import React, { Component } from 'react';
import { List, ListItem, ListItemText, Paper, Button, Divider, FormControl, InputLabel, Select, MenuItem, FormGroup, FormControlLabel, Switch, IconButton, ListItemAvatar, TextField, Box, Autocomplete, LinearProgress } from '@mui/material';
import { ChevronRight, ChevronLeft, Close } from '@mui/icons-material';
import Api from '../../customlib/Api';
import axios from 'axios';
import Global from '../../customlib/Global';
import ReactLoading from 'react-loading';

class EditTeamLeader extends Component {
    state = { 
        listUsers: [],
        countLavengerUser: 0,
        countNotLavengerUser: 0,
        isSaving: false,
        message: "Klik User Bukan member agar menjadi Member Team ini",
        isError: false,
        appProfile: {
            _id: "-",
            appProfileId: Global.getAppProfile()._id,
            teamLeaderName: "",
            leaderId: 0,
            leaderName: "",
            leaderType: "",
            members: [],
            isTeamEnabled: true 
        },
        listUserLavender: [],
        listUserLotus: [],
        keywordLavenderUser: "",
        keywordLotusUser: "",
        salesData: [],
        selectedSales: {}
    }

    getLavengerUsers = () => {

        const params = {
            appProfileId: Global.getAppProfile()._id,
            teamLeaderId: this.state.appProfile._id
        };

        axios
        .post(Api.teamLeaderMembers(), params, Api.getRequestHeader())
        .then((response) => {

            console.log("LAVENGER USERS : ", response.data);

            var users = response.data.data;
            var lotusUsers = users.filter(user => user.isTeamLeaderMember === true);
            var lavenderUsers = users.filter(user => user.isTeamLeaderMember === false);
            var countLavengerUser = lotusUsers.length;
            var countNotLavengerUser = lavenderUsers.length;

            console.log("LAVENGERUSERS : ", users);
            this.setState({listUsers: users, listUserLavender: lavenderUsers, listUserLotus: lotusUsers, countLavengerUser: countLavengerUser, countNotLavengerUser: countNotLavengerUser});
        })
        .catch((error) => {
            console.error("There was an error!", error);
        });
    };

    filterUserLavender = (keyword) => {
        return this.state.listUsers.filter(user => user.isTeamLeaderMember === false && 
            (
            user.email.toLowerCase().includes(`${keyword}`.toLowerCase()) || 
            user.name.toLowerCase().includes(`${keyword}`.toLowerCase())
            )
        );
    }

    filterUserLotus = (keyword) => {
        return this.state.listUsers.filter(user => user.isTeamLeaderMember === true && 
            (
            user.email.toLowerCase().includes(`${keyword}`.toLowerCase()) || 
            user.name.toLowerCase().includes(`${keyword}`.toLowerCase())
            )
        );
    }

    saveLavengerUsers = () => {

        console.log(this.state.appProfile);

        this.setState({isSaving: true},() => {
            let message = "";

            const newChatUsers = this.state.listUsers.filter(user => user.isTeamLeaderMember === true);

            var newChatUserIds = [];
            newChatUsers.forEach(user => {
                newChatUserIds.push(user.id);
            });

            const params = {...this.state.appProfile}
            // params.leaderId = this.state.selectedSales.
            params.id = params._id ?? "-";
            params.members = newChatUserIds;
            params.updatedBy = Global.get().user.id;
            params.updatedByName = Global.get().user.name;
            console.log("PARAMS_SAVE", params);
            // return;
            axios
            .post(Api.teamLeaderSave(), params, Api.getRequestHeader())
            .then((response) => {

                message = response.data.message;
                let isSuccess = response.data.success;

                console.log("RESPONSE : ", response.data);
                this.setState({isSaving: false, message: message, isError: !response.data.success},()=>{
                    this.props.onReload();
                    if(isSuccess){
                        this.props.onClose();
                    }
                });
            })
            .catch((error) => {
                this.setState({isSaving: false, message: message, isError: true});
                console.error("There was an error!", error);
            });
        });
    };

    handleMoveUser = (userData) => {
        const users = [...this.state.listUsers];
        var findUser = users.filter(user => user.id === userData.id);
        

        try{
            if(findUser.length > 0){
                findUser[0].isTeamLeaderMember = !findUser[0].isTeamLeaderMember;
            }

            var countLavengerUser = users.filter(user => user.isTeamLeaderMember === true).length;
            var countNotLavengerUser = users.filter(user => user.isTeamLeaderMember === false).length;
            this.setState(
                {
                    listUsers: users, 
                    countLavengerUser: countLavengerUser, 
                    countNotLavengerUser: countNotLavengerUser,
                    message: "Perubahan belum disimpan, klik tombol simpan"
                }
            );

        }catch(err){
            console.log(err);
        }


    }

    handleTeamLeaderNameChanged = (event) => {
        const appProfile = {...this.state.appProfile}
        appProfile.teamLeaderName = event.target.value;
        this.setState({appProfile: appProfile});
    }

    handleAppWaNumberChanged = (event) => {
        const appProfile = {...this.state.appProfile}
        appProfile.waNumber = event.target.value;
        this.setState({appProfile: appProfile});
    }

    handleAppKeyChanged = (event) => {
        const appProfile = {...this.state.appProfile}
        appProfile.appKey = event.target.value;
        this.setState({appProfile: appProfile});
    }

    handleWabaIdChanged = (event) => {
        const appProfile = {...this.state.appProfile}
        appProfile.wabaId = event.target.value;
        this.setState({appProfile: appProfile});
    }
    handleKeywordLavenderChanged = (event) => {
        this.setState({keywordLavenderUser: event.target.value});
    }
    handleKeywordLotusChanged = (event) => {
        this.setState({keywordLotusUser: event.target.value});
    }

    handleSwitchLeads = () => {
        let currentAppEnabledState = this.state.appProfile.isTeamEnabled;
        let appProfile = {...this.state.appProfile}
        appProfile.isTeamEnabled = !currentAppEnabledState;
        this.setState({appProfile: appProfile});
    }

    handleLeaderTypeChanged = (event) => {
        const appProfile = {...this.state.appProfile}
        appProfile.leaderType = event.target.value;
        this.setState({appProfile: appProfile});
    }
    
    handleAppVendorChanged = (event) => {
        const appProfile = {...this.state.appProfile}
        appProfile.appVendor = event.target.value;
        this.setState({appProfile: appProfile});
    }

    componentDidMount() {
        console.log("PROPS : ",this.props.data);
        let teamLeaderData = {...this.state.appProfile};
        if(this.props.data){
            teamLeaderData = this.props.data;
        }
        this.setState({
            appProfile: teamLeaderData
        }, () => {
            this.getLavengerUsers();
            this.getSalesTeleUsers();
        });

        // let appProfile = {
        //     appProfileId: this.props.data._id,
        //     waNumber: this.props.data.waNumber,
        //     appType: this.props.data.type,
        //     appLabel: this.props.data.label,
        //     appEnabled: this.props.data.enabled,
        //     appVendor: this.props.data.appVendor, 
        //     appKey: this.props.data.appKey,
        //     wabaId: this.props.data.wabaId 
        // }
        
        
    }

    handleSelectionChanged = (salesName) => {
        const salesData = [...this.state.salesData];
        // console.log("SALESDATA : ", salesData);
        let selected = salesData.filter((sales) => sales.name===salesName);
        console.log("FINDSELECTION : ", selected);
  
        if(selected.length > 0){
            let newData = JSON.parse(JSON.stringify(selected[0]));
            let teamLeader = {...this.state.appProfile};
            
            newData.lavenderSalesId = selected.id;
            teamLeader.leaderId = selected[0].id;
            teamLeader.leaderName = selected[0].name;
            this.setState({
              selectedSales: newData,
              lavenderSalesId: selected[0].id,
              lavenderSalesName: selected[0].name,
              appProfile: teamLeader
            });
            console.log(selected[0].id);
            console.log(selected[0].name);
            
  
            // console.log(this.state.lavenderSalesId );
            // console.log(this.state.lavenderSalesName);
        }
  
    }

    getSalesTeleUsers = () => {

        const params = {
            slugRoles: ["tele-leader-new", "admin-tele", "account-executive"]
            // slugRole: "account-executive"
        };

        axios
        // .post(Api.getSalesTeleUserList(), {}, Api.getRequestHeader())
        .post(Api.userBySlugRoles(), params, Api.getRequestHeader())
        .then((response) => {
            console.log("SALESTELEUSER : ", response.data.data);
            this.setState({salesData: response.data.data});
        })
        .catch((error) => {
            console.error("There was an error!", error);
        });
    };

    render() { 
        return ( 
            <Paper>
                <div className="container">
                    <div className="row">
                        <div className="col-9">

                            {
                                this.state.isSaving ? 
                                (
                                    // <><ReactLoading type="bubbles" width="50" height="20" /> Sedang menyimpan ....</>
                                    <LinearProgress />
                                ) : (<></>)
                                
                            }
                            <div className={this.state.isSaving ? "alert alert-warning" : this.state.isError ? "alert alert-danger" : "alert alert-primary"}>
                                {this.state.isSaving ? "Sedang menyimpan..." : this.state.message}
                            </div>

                        </div>
                        <div className="col-2">
                            <Button sx={{mt: "8px"}} color='primary' variant='contained' disabled={this.state.isSaving} fullWidth onClick={this.saveLavengerUsers}>
                                Simpan
                            </Button> 
                            {/* <div className="btn btn-primary btn-block" onClick={this.saveLavengerUsers}>
                                Simpan
                            </div> */}
                        </div>
                        <div className="col-1">
                            <IconButton sx={{mt: "8px"}} variant='contained' color="error" onClick={this.props.onClose}><Close /></IconButton>
                        </div>
                    </div>
                    <Divider style={{marginTop: 10, marginBottom: 10}} />

                    <Paper>
                        <div className="container">
                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group">
                                        {/* <label>App Name</label>
                                        <input
                                            onChange={this.handleAppNameChanged}
                                            value={this.state.appProfile.appLabel}
                                            type="name"
                                            className="form-control"
                                            id="appName"
                                            aria-describedby="emailHelp"
                                        /> */}
                                        <TextField 
                                            id="txt-app-name" 
                                            label="Nama Team" 
                                            variant="outlined" 
                                            type='text'
                                            onChange={this.handleTeamLeaderNameChanged}
                                            value={this.state.appProfile.teamLeaderName}
                                            fullWidth
                                            size='small'
                                        />
                                    </div>
                                    <div className="form-group">
                                        <Autocomplete
                                            id="free-solo-2-demo"
                                            disableClearable
                                            freeSolo 
                                            size='small'
                                            options={this.state.salesData.map((option) => {
                                                // console.log("LABEL : ", option);
                                                // return String(`${option.name} (${option.email})`) ;
                                                return String(`${option.name}`) ;
                                            })}
                                            
                                            onChange={(event, newValue) => {
                                                // console.log("NEWVALUE : ", event);
                                                this.handleSelectionChanged(newValue);
                                            }} 
                                            // value={this.state.contactData.lavenderSalesName}
                                            value={this.state.appProfile.leaderName}
                                            renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Nama Leader"
                                                // margin="0"
                                                variant="outlined"
                                                InputProps={{ ...params.InputProps, type: 'search' }}
                                            />
                                            )}
                                        />
                                        {/* <TextField 
                                            id="txt-wa-number" 
                                            label="Nama Leader" 
                                            variant="outlined" 
                                            type='tel'
                                            onChange={this.handleAppWaNumberChanged}
                                            value={this.state.appProfile.waNumber}
                                            fullWidth
                                            size='small'
                                        /> */}
                                    </div>
                                    {/* <FormControl size='small' variant="outlined" style={{width: '100%', marginTop: 0}}>
                                        <InputLabel id="demo-simple-select-outlined-label">Vendor Aplikasi</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            value={this.state.appProfile.appVendor}
                                            onChange={this.handleAppVendorChanged}
                                            label="Tipe Aplikasi"
                                        >
                                            <MenuItem key="vendorInfobip" value="INFOBIP">Infobip</MenuItem>
                                            <MenuItem key="vendorVonage" value="VONAGE">Vonage</MenuItem>
                                            <MenuItem key="vendorVonage" value="QONTAK">Qontak</MenuItem>
                                            <MenuItem key="vendorVonage" value="BION">Bion</MenuItem>
                                            <MenuItem key="vendorVonage" value="BION CRM">Bion CRM</MenuItem>
                                        </Select>
                                    </FormControl> */}
                                    
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <FormControl size='small' variant="outlined" style={{width: '100%', marginTop: 0}}>
                                            <InputLabel id="demo-simple-select-outlined-label">Tipe Team</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-outlined-label"
                                                id="demo-simple-select-outlined"
                                                value={this.state.appProfile.leaderType}
                                                onChange={this.handleLeaderTypeChanged}
                                                label="Tipe Team"
                                            >
                                                <MenuItem key="tipeSales" value="SALES_ONLINE">Sales Online</MenuItem>
                                                <MenuItem key="tipePurchasing" value="TELEMARKETING">Telemarketing</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="form-group">
                                        <Box>
                                            <FormGroup variant="outlined" style={{marginTop: 7}}>
                                                <FormControlLabel
                                                    label= {this.state.appProfile.isTeamEnabled === true ? "Team is (ACTIVE)" : "Team is (INACTIVE)"}
                                                    control={
                                                        <Switch
                                                            checked={this.state.appProfile.isTeamEnabled === true}
                                                            onChange={this.handleSwitchLeads}
                                                            name="switchLeads"
                                                            // color="primary"
                                                        />
                                                    }
                                                />
                                            </FormGroup> 
                                        </Box>
                                        {/* <label>App Key</label>
                                        <input
                                            onChange={this.handleAppKeyChanged}
                                            value={this.state.appProfile.appKey}
                                            type="text"
                                            className="form-control"
                                            id="appKey"
                                            aria-describedby="appKey"
                                            onKeyDown={this.onKeyDownHandler}
                                        /> */}
                                        {/* <TextField 
                                            id="txt-app-key" 
                                            label="App Key" 
                                            variant="outlined" 
                                            type='text'
                                            onChange={this.handleAppKeyChanged}
                                            value={this.state.appProfile.appKey}
                                            fullWidth
                                            size='small'
                                            multiline
                                            maxRows={3}
                                        /> */}
                                    </div>
                                    {/* <div className="form-group">
                                        <TextField 
                                            id="txt-wabaid" 
                                            label="Waba ID" 
                                            variant="outlined" 
                                            type='text'
                                            onChange={this.handleWabaIdChanged}
                                            value={this.state.appProfile.wabaId}
                                            fullWidth
                                            size='small'
                                        />
                                    </div> */}
                                </div>
                            </div>
                            
                        </div>
                    </Paper>
                    <br />
                    <div className="row">
                        <div className="col-6">
                            <Paper elevation={3} style={{width: "100%", padding: 10}}>
                                <div className="row">
                                    <div className="col-9">
                                        <h4>Bukan Member</h4>
                                    </div>
                                    <div className="col-2 text-right">
                                        <div style={{marginBottom: 10}} className="badge badge-primary">{this.state.countNotLavengerUser} User</div>
                                    </div>
                                </div>
                                {/* <Divider sx={{marginTop: "5px", marginBottom: "5px"}} /> */}
                                <TextField 
                                    id="txt-keyword-lavender" 
                                    label="pencarian user bukan member team" 
                                    variant="outlined" 
                                    type='text'
                                    onChange={this.handleKeywordLavenderChanged}
                                    value={this.state.keywordLavenderUser}
                                    fullWidth
                                    size='small'
                                />
                                <List style={{maxHeight: 470, overflowY: "scroll", marginTop: "10px"}}>
                                    {
                                    // this.state.listUsers.filter(user => user.isTeamLeaderMember === false).map(user => 
                                    this.filterUserLavender(this.state.keywordLavenderUser).map(user => 
                                        (
                                            <ListItem sx={{cursor: "pointer"}} dense key={user.id} onClick={() => {this.handleMoveUser(user)}}
                                                secondaryAction={
                                                    // <IconButton edge="end" aria-label="delete">
                                                        <ChevronRight style={{marginTop: 5}} />
                                                    // </IconButton>
                                                }
                                                >
                                                <ListItemText
                                                    primary={user.name}
                                                    secondary={user.email}
                                                />
                                            </ListItem>
                                        )
                                        // (<ListItem button key={user.id} onClick={() => {this.handleMoveUser(user)}}>
                                        //     <div className="row">
                                        //         <div className="col-11">
                                        //             <ListItemText primary={user.name + " - " + user.email} />
                                        //         </div>
                                        //         <div className="col-1">
                                        //             <ChevronRight style={{marginTop: 5}} />
                                        //         </div>
                                        //     </div>
                                        // </ListItem>)
                                    )
                                    }
                                </List>
                            </Paper>
                        </div>
                        {/* <div className="col-2"></div> */}
                        <div className="col-6">
                            <Paper elevation={3} style={{width: "100%", padding: 10}}>
                                <div className="row">
                                    <div className="col-9">
                                        <h4>Member Team</h4>
                                    </div>
                                    <div className="col-2 text-right">
                                        <div style={{marginBottom: 10}} className="badge badge-primary">{this.state.countLavengerUser} User</div>
                                    </div>
                                </div>
                                {/* <Divider sx={{marginTop: "5px", marginBottom: "5px"}} /> */}
                                <TextField 
                                    id="txt-keyword-lotus" 
                                    label="Pencarian member team" 
                                    variant="outlined" 
                                    type='text'
                                    onChange={this.handleKeywordLotusChanged}
                                    value={this.state.keywordLotusUser}
                                    fullWidth
                                    size='small'
                                />
                                <List style={{maxHeight: 470, overflowY: "scroll", marginTop: "10px"}}>
                                    {
                                    // this.state.listUsers.filter(user => user.isTeamLeaderMember === true).map(user => 
                                    this.filterUserLotus(this.state.keywordLotusUser).map(user => 
                                        (
                                            <ListItem dense key={user.id} sx={{cursor: "pointer"}} onClick={() => {this.handleMoveUser(user)}} >
                                                <ListItemAvatar>
                                                    <ChevronLeft />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={user.name}
                                                    secondary={user.email}
                                                />
                                            </ListItem>
                                        )
                                    //     (<ListItem button key={user.id} onClick={() => {this.handleMoveUser(user)}}>
                                    //     <div className="row">
                                    //         <div className="col-1 text-left">
                                    //             <ChevronLeft style={{marginTop: 5}} />
                                    //         </div>
                                    //         <div className="col-11">
                                    //             <ListItemText primary={user.name + " - " + user.email} />
                                    //         </div>
                                    //     </div>
                                    // </ListItem>)
                                    )
                                    }
                                    
                                </List>
                            </Paper>
                        </div>
                    </div>
                </div>
            </Paper>
        );
    }
}
 
export default EditTeamLeader;